import { getAppConfig } from '../../../common/config/app-config';

export const {
  APP_CONFIG,
  unbxdSearchConfig: { countdownThreshold },
  sellingOutFast,
} = getAppConfig();

export function roundToCeil(val) {
  const ceilVal = Math.ceil(val);
  return ceilVal;
}

export function roundToFloor(val) {
  const ceilVal = Math.floor(val);
  return ceilVal;
}
export function getRoundedFloorPrice(val) {
  const roundToValue = 10;
  const result = roundToCeil(val / roundToValue) * roundToValue;
  return result;
}

export function getRoundedCeilPrice(val) {
  const roundToValue = 10;
  const result = roundToCeil(val / roundToValue) * roundToValue;
  return result;
}

export function getDividedMaxPrice(minPrice, maxPrice) {
  const priceSubstracted = maxPrice - minPrice;
  const PriceDivided = priceSubstracted / 4;
  const priceDiff = roundToCeil(PriceDivided / 10) * 10;
  return priceDiff;
}
